module.exports = __webpack_public_path__ + "img/pexels-alexander-ant-7004737.4d399f9e.jpg";